import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';
import { fetchServiceDataForServiceType } from '../../../../actions/services-api';
import { useDispatch, useSelector } from 'react-redux';
import { CheckboxCard } from './checkboxCard';
import { ConnectionTypes, isSocialNetwork } from '../../../../constants/utils/connectionTypes';

export const ServiceNavbar = ({ selectedService, setSelectedService, personnalOptions, commonOptions, otherOption }) => {
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const user = useSelector(state => state.user);
    const bottomRef = useRef(null);
    const topRef = useRef(null);
    const selectedServiceRef = useRef(null);
    const [selectedServices, setSelectedServices] = useState([]);
    const isFirefox = typeof InstallTrigger !== 'undefined';

    function isInsurance(str) {
        if (str === ConnectionTypes.scooter || str === ConnectionTypes.moto || str === ConnectionTypes.bateau || str === ConnectionTypes.voitureAssurance ||
            str === ConnectionTypes.insurance) {
            return true;
        }
        return false;
    }

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user) && !R.isNil(user.services) && user.services !== []) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (!R.isNil(selectedServiceRef) && !R.isNil(selectedServiceRef.current)) {
                selectedServiceRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 350);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedService]);

    useEffect(() => {
        dispatch(fetchServiceDataForServiceType(selectedService))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedService]);

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user.services) && user.services.length > 0) {
            setSelectedServices(user.services);
            if (!R.isNil(selectedService) && selectedService !== '' && user.services.findIndex(s => s.connectionType === selectedService) === -1) {
                let serviceToBeSet = R.sortWith([R.ascend(R.prop('title'))])(Object.entries([].concat(commonOptions, personnalOptions, otherOption).filter(sr => selectedServices.findIndex(r =>
                    isSocialNetwork(r.connectionType) ? ConnectionTypes.socialNetworks === sr.connectionType :
                        isInsurance(r.connectionType) ? ConnectionTypes.insurance === sr.connectionType :
                            r.connectionType === sr.connectionType) !== -1)).map(entry => entry[1]))[0];
                setSelectedService(isSocialNetwork(serviceToBeSet.connectionType) ? ConnectionTypes.socialNetworks : isInsurance(serviceToBeSet.connectionType) ? ConnectionTypes.insurance : serviceToBeSet.connectionType);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.services]);

    return (
        <nav className="block flex-row flex-lg-column align-items-center no-scroll">
            <h2 className="sr-only visually-hidden">Services Navigation</h2>
            <header className="block w-lg-100 sticky-auto t-auto-0 z-2 mr-3 mx-lg-auto text-center bg-light pb-1">
                <button type="button" className="btn btn-icon mx-auto bnt-auto-block o-60 o-100--hover p-0 no-outline" onClick={(e) => {
                    e.preventDefault();
                    if (!R.isNil(topRef) && !R.isNil(topRef.current)) {
                        topRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }}>
                    <i className=" eva eva-arrow-upward-outline fs-4"></i>
                </button>
            </header>
            <ul className={"list-unstyled sticky-auto z-0 grid grid-auto-column w-100" + (isFirefox ? ' pb-5' : '')}>
                {R.sortWith([R.ascend(R.prop('title'))])(Object.entries(commonOptions.filter(sr => selectedServices.findIndex(r => r.connectionType === sr.connectionType) !== -1)).map(entry => entry[1])).map((s, index) => {
                    let votreBanque = false;
                    let compteCourant = false;
                    let votrePlacements = false;
                    let votreAssurance = false;
                    let votreCredit = false;
                    if (s.connectionType === ConnectionTypes.bank) {
                        let bankData = services.serviceData["Bank"];
                        if (!R.isNil(bankData) && bankData.length > 0) {
                            votreBanque = true;
                            // compteCourant = true;
                            // votrePlacements = true;
                            // votreAssurance = true;
                            // votreCredit = true;
                            bankData.forEach(bank => {
                                if (compteCourant === false && bank.payload.accounts.findIndex(b => b.category === "Courant") !== -1) {
                                    compteCourant = true;
                                }
                                if (votrePlacements === false && bank.payload.accounts.findIndex(b => b.category === "Placement") !== -1) {
                                    votrePlacements = true;
                                }
                                if (votreAssurance === false && bank.payload.accounts.findIndex(b => b.category === "Assurance") !== -1) {
                                    votreAssurance = true;
                                }
                                if (votreCredit === false && bank.payload.accounts.findIndex(b => b.category === "Credit") !== -1) {
                                    votreCredit = true;
                                }
                            });
                        }
                    }

                    let labels = {
                        [ConnectionTypes.bank]: [
                            { isActive: votreBanque, name: "Votre banque" },
                            { isActive: compteCourant, name: "Votre compte courant" },
                            { isActive: votrePlacements, name: "Vos placements" },
                            { isActive: votreAssurance, name: "Vos assurances" },
                            { isActive: votreCredit, name: "Vos credits" },
                        ]
                    };

                    return (
                        <li key={index} ref={index === 0 ? topRef : index === [].concat(commonOptions, personnalOptions, otherOption).filter(sr => selectedServices.findIndex(r => r.connectionType === sr.connectionType) !== -1).length - 1 ? bottomRef : s.connectionType === selectedService ? selectedServiceRef : undefined} role="button" className={"card rounded border border-dim " + (selectedService === s.connectionType ? ' shadow' : '')} onClick={(e) => {
                            e.preventDefault();
                            setSelectedService(s.connectionType);
                        }}>
                            <CheckboxCard isSelected={selectedService === s.connectionType} topRef={topRef} selectedServices={selectedServices} setSelectedServices={setSelectedServices} service={s} labels={labels[s.connectionType]} />
                        </li>
                    )
                })}

                {R.sortWith([R.ascend(R.prop('title'))])(Object.entries(personnalOptions.filter(sr => selectedServices.findIndex(r => isSocialNetwork(r.connectionType) ? ConnectionTypes.socialNetworks === sr.connectionType :
                    isInsurance(r.connectionType) ? ConnectionTypes.insurance === sr.connectionType :
                        r.connectionType === sr.connectionType) !== -1)).map(entry => entry[1])).map((s, index) => {
                            let idx = index + commonOptions.length;
                            return (
                                <li key={idx} ref={idx === [].concat(personnalOptions, otherOption).filter(sr => selectedServices.findIndex(r => r.connectionType === sr.connectionType) !== -1).length - 1 ? bottomRef : s.connectionType === selectedService ? selectedServiceRef : undefined} role="button" className={"card rounded border border-dim " + (selectedService === s.connectionType ? ' shadow' : '')} onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedService(s.connectionType);
                                }}>
                                    <CheckboxCard isSelected={selectedService === s.connectionType} topRef={topRef} isSocialNetwork={isSocialNetwork} isInsurance={isInsurance}
                                        selectedServices={selectedServices} setSelectedServices={setSelectedServices} service={s} />
                                </li>
                            )
                        })}

                {Object.entries(otherOption.filter(sr => selectedServices.findIndex(r => r.connectionType === sr.connectionType) !== -1)).map(entry => entry[1]).map((s, index) => {
                    let idx = index + commonOptions.length + personnalOptions.length;
                    return (
                        <li key={idx} ref={s.connectionType === selectedService ? selectedServiceRef : bottomRef} role="button" className={"card rounded border border-dim " + (selectedService === s.connectionType ? ' shadow' : '')} onClick={(e) => {
                            e.preventDefault();
                            setSelectedService(s.connectionType);
                        }}>
                            <CheckboxCard isSelected={selectedService === s.connectionType} topRef={topRef} selectedServices={selectedServices} setSelectedServices={setSelectedServices} service={s} />
                        </li>
                    )
                })}

            </ul>
            <footer className="block w-lg-100 sticky-auto b-auto-0 z-2 ml-3 mx-lg-auto text-center bg-light pt-1">
                <button type="button" className="btn btn-icon mx-auto bnt-auto-block o-60 o-100--hover p-0 no-outline" onClick={(e) => {
                    e.preventDefault();
                    if (!R.isNil(bottomRef) && !R.isNil(bottomRef.current)) {
                        bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }}>
                    <i className="eva eva-arrow-downward-outline fs-4"></i>
                </button>
            </footer>
        </nav>
    )
}